import React from "react";
import {
    Button,
    Image,
    Text,
    useColorModeValue,
    HStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import logo from "../../../assets/logo.png";

const HomeButton: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = () => {
        navigate("/");
    };

    const textColor = useColorModeValue("#003552", "blue.200");

    return (
        <Button
            aria-label={t("goHome") || "Go to Home"}
            onClick={handleClick}
            mr={4}
            variant="unstyled"
            transition="all 0.3s ease"
            _hover={{
                transform: "scale(1.05)",
                textShadow: "0px 2px 6px rgba(0,0,0,0.15)",
            }}
            _active={{
                transform: "scale(0.98)",
            }}
        >
            <HStack spacing={3} align="center">
                <Image src={logo} alt="Company Logo" boxSize={10} />
                <Text
                    color={textColor}
                    fontWeight="bold"
                    fontSize={{ base: "lg", md: "2xl" }}
                    letterSpacing="wide"
                >
                    {t("Titre")}
                </Text>
            </HStack>
        </Button>
    );
};

export default HomeButton;
